export default __webpack_public_path__ + "static/media/search.4f1c78e9.svg";